/**
 * テーブルの行データを取得する。
 *
 * @param {object} fieldBlocks
 * @param {string} handle
 * @returns {any|void}
 */
import { deepCopy } from '../methods/deepCopy.js';

export function getDefaultTableRowData(fieldBlocks, handle) {
    const fieldBlock = fieldBlocks[handle];
    const rowData = {};
    fieldBlock.fields.forEach(function (_handle) {
        if (typeof fieldBlocks[_handle] === 'undefined') {
            throw new Error(`fieldBlocks['${handle}'] is not found.`);
        } else if (typeof fieldBlocks[_handle].data === 'undefined') {
            throw new Error(`The 'data' property for fieldBlocks['${_handle}'] is required.`);
        }
        rowData[_handle] = deepCopy(fieldBlocks[_handle].data);
    });
    return rowData;
}
